import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CircleIcon from '@mui/icons-material/Circle';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';

const QuickGuideItem = ({ item }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'dashboard.guide' });

  return (
    <TimelineItem
      sx={{
        '&::before': {
          display: 'none',
        },
        minHeight: '19/vh',
      }}
    >
      <TimelineSeparator>
        <TimelineDot
          sx={{
            p: '6px',
            m: 0,
            bgcolor: item.color,
            color: 'white',
          }}
        >
          <img src={item.icon} />
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent
        sx={{
          p: theme => theme.spacing(2, 0),
          ml: 2.5,
        }}
      >
        <Link to={item.route} style={{ textDecoration: 'none' }}>
          <Typography variant='h5' mb={0.5} color={ColorsV2.white} fontSize={'1em'}>
            {t(item.title)}
          </Typography>
        </Link>
        <Typography
          variant='body1'
          color={ColorsV2.white}
          sx={{ fontFamily: 'DM Sans, sans-serif' }}
          fontSize={'0.8em'}
          gutterBottom
        >
          {t(item.subTitle)}
        </Typography>

        {item?.subTitle2?.map(item => (
            <Stack
              direction='row'
              spacing={1}
              alignItems='center'
              color={ColorsV2.white}
              key={item.title}
              sx={{ marginLeft: '10px' }}
            >
              <CircleIcon sx={{ height: '5px', width: '5px' }} />
              <Typography
                variant='body2'
                sx={{
                  fontFamily: 'DM Sans, sans-serif',
                }}
                fontSize={'0.8em'}
              >
                {t(item.title)}
              </Typography>
            </Stack>
        ))}
      </TimelineContent>
    </TimelineItem>
  );
};
export default QuickGuideItem;
